import { AppLauncher } from '@capacitor/app-launcher';
import { directionsUrl } from '../lib/format';
import { isNative } from '../lib/platform';

/**
 * Hands navigation to Google Maps. In the app, google.navigation: starts turn-by-turn straight
 * away; without the Maps app the directions URL opens in the browser instead. Phase 1 has no
 * in-app navigation.
 */
export async function driveTo(to: { lat: number; lng: number }): Promise<void> {
  const web = directionsUrl(to);
  if (!isNative) {
    window.open(web, '_blank', 'noopener');
    return;
  }
  try {
    const { completed } = await AppLauncher.openUrl({ url: `google.navigation:q=${to.lat},${to.lng}` });
    if (completed) return;
  } catch {
    /* fall through to the web link */
  }
  await AppLauncher.openUrl({ url: web });
}

/** Opens a link outside the app: the Maps app or the browser on a phone, a new tab on the website. */
export async function openExternal(url: string): Promise<void> {
  if (!isNative) {
    window.open(url, '_blank', 'noopener');
    return;
  }
  await AppLauncher.openUrl({ url });
}
